import { backUrl } from "../utils/backURL";
import { fetchWrapper, handleSessionExpiration } from "../utils/fetchWrapper";
import { withAuthCredentials } from "../utils/authFetchOptions";
import { leerEventos } from "../utils/cierreConsolidado";

export const getEmployees = async (requesterId, token) => {
  const res = await fetchWrapper(`${backUrl}/mantisBusiness/getEmployees/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      mantisBusinessId: requesterId,
      activeEmployees: false,
    }),
  });

  return res;
};

export const getActiveEmployees = async (requesterId, token) => {
  const res = await fetchWrapper(`${backUrl}/mantisBusiness/getEmployees/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      mantisBusinessId: requesterId,
      activeEmployees: true,
    }),
  });

  return res;
};

export const createEmployee = async (requesterId, token, employeeData) => {
  const res = await fetchWrapper(`${backUrl}/mantisBusiness/createEmployee/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      mantisBusinessId: requesterId,
      employeeData,
    }),
  });

  return res;
};

export const getEmployeeFolders = async (userId, mantisBusinessId, token) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/getEmployeeFolders/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        userId,
        mantisBusinessId,
      }),
    }
  );

  return res;
};

export const getBusinessFolders = async (mantisBusinessId, token) => {
  const res = await fetchWrapper(`${backUrl}/mantisBusiness/archive/folders`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      mantisBusinessId,
    }),
  });

  return res;
};

export const getBusinessEmails = async (mantisBusinessId, token) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/getBusinessEmails/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
      }),
    }
  );

  return res;
};

export const getEmployeeFolderById = async (
  folderId,
  mantisBusinessId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/getEmployeeFolderById/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        folderId,
        mantisBusinessId,
      }),
    }
  );

  return res;
};

export const getBusinessFolderById = async (
  folderId,
  token,
  mantisBusinessId,
  page
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/folderById/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        folderId,
        mantisBusinessId,
        page,
      }),
    }
  );

  return res;
};

export const createEmployeeFolder = async (
  parentFolderId,
  folderData,
  mantisBusinessId,
  userId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/createEmployeeFolder/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        parentFolderId,
        folderData,
        mantisBusinessId,
        userId,
      }),
    }
  );

  return res;
};

export const createBusinessFolder = async (
  token,
  parentFolderId,
  folderData,
  mantisBusinessId,
  mantisBusinessUserId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/createFolder/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        parentFolderId,
        folderData,
        mantisBusinessId,
        mantisBusinessUserId,
      }),
    }
  );

  return res;
};

export const createEmployeeDocument = async (
  folderId,
  base64,
  name,
  type,
  mantisBusinessId,
  userId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/createEmployeeDocument/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        folderId,
        base64,
        name,
        type,
        mantisBusinessId,
        userId,
      }),
    }
  );

  return res;
};

export const createBusinessDocument = async (
  folderId,
  base64,
  name,
  type,
  fileDate,
  fileSize,
  mantisBusinessId,
  mantisBusinessUserId,
  token,
  documentFormatId,
  formatValues,
  suggestedFileLocation
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/createBusinessDocument/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        folderId,
        base64,
        name,
        type,
        mantisBusinessId,
        mantisBusinessUserId,
        fileDate,
        fileSize,
        documentFormatId,
        formatValues,
        suggestedFileLocation,
      }),
    }
  );

  return res;
};

export const createBusinessCompressedFolder = async (
  folderId,
  base64,
  name,
  mantisBusinessId,
  mantisBusinessUserId,
  level,
  token,
  fileDate
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/createBusinessCompressedFolder/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        folderId,
        base64,
        name,
        mantisBusinessId,
        mantisBusinessUserId,
        level,
        fileDate,
      }),
    }
  );

  return res;
};

export const getMantisBusinessNotificationNumber = async (
  mantisBusinessId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/notifications/getMantisBusinessUnreadNotificationsAmount`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId }),
    }
  );

  return res;
};

export const getMantisBusinessNotifications = async (
  mantisBusinessId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/notifications/getMantisBusinessNotifications`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId }),
    }
  );

  return res;
};

export const sendCellphoneVerification = async (cellphone) => {
  const res = await fetchWrapper(
    `${backUrl}/verify/sendBusinessCellphoneVerification`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ cellphone }),
    }
  );

  return res;
};

export const verifyCellphone = async (cellphone, code) => {
  const res = await fetchWrapper(
    `${backUrl}/verify/verifyMantisBusinessCellphone`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ cellphone, code }),
    }
  );

  return res;
};

export const getBusinessPermissions = async (
  requesterId,
  mantisBusinessId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/getBusinessPermissions`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        requesterId,
        mantisBusinessId,
      }),
    }
  );

  return res;
};

export const createMantisBusinessUser = async (
  mantisBusinessId,
  userId,
  token,
  userData
) => {
  try {
    const res = await fetchWrapper(
      `${backUrl}/mantisBusiness/userManagement/createUser`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          mantisBusinessUserId: userId,
          mantisBusinessId,
          userData,
        }),
      }
    );
    return res;
  } catch (error) {
    console.error("Error in updateMantisBusinessUser:", error);
    throw error;
  }
};

export const updateMantisBusinessUser = async (
  mantisBusinessUserId,
  mantisBusinessUserToUpdateId,
  userData,
  token,
  mantisBusinessId
) => {
  try {
    console.log(
      "Making API request to:",
      `${backUrl}/mantisBusiness/userManagement/editUser`
    );
    console.log("Request payload:", {
      mantisBusinessUserId,
      mantisBusinessUserToUpdateId,
      userData,
    });
    console.log("Token:", token); // Agregar este log para verificar el token

    const res = await fetchWrapper(
      `${backUrl}/mantisBusiness/userManagement/editUser`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Verifica que el token se envíe correctamente
        },
        body: JSON.stringify({
          mantisBusinessUserId,
          mantisBusinessUserToUpdateId,
          userData,
          mantisBusinessId,
        }),
      }
    );
    return res;
  } catch (error) {
    console.error("Error in updateMantisBusinessUser:", error);
    throw error;
  }
};

export const getMantisBusinessUsers = async (mantisBusinessId, token) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/userManagement/getUsers`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
      }),
    }
  );
  return res;
};

export const deleteMantisBusinessUser = async (
  mantisBusinessId,
  userId,
  mantisBusinessUserToDeleteId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/userManagement/deleteUser`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessUserId: userId,
        mantisBusinessId,
        mantisBusinessUserToDeleteId,
      }),
    }
  );
  return res;
};

export const sendRecoverPasswordEmail = async (email) => {
  const res = await fetchWrapper(`${backUrl}/passwordReset/business`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });

  return res;
};

export const resetPassword = async (token, newPassword) => {
  const resetPasswordReq = await fetchWrapper(
    `${backUrl}/passwordReset/business/changePassword`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token,
        newPassword,
      }),
    }
  );
  return resetPasswordReq;
};

export const getLatestAssistantConversation = async (
  mantisBusinessUserId,
  mantisBusinessId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/sapiens/getLatestConversation`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessUserId, mantisBusinessId }),
    }
  );

  return res;
};

export const getAssisstantConversationsHistory = async (
  mantisBusinessUserId,
  mantisBusinessId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/sapiens/getConversationHistory`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessUserId, mantisBusinessId }),
    }
  );
  return res;
};

export const getAssistantConversationById = async (
  businessAssistantConversationId,
  mantisBusinessId,
  mantisBusinessUserId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/sapiens/getConversationById`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        businessAssistantConversationId,
        mantisBusinessId,
        mantisBusinessUserId,
      }),
    }
  );

  return res;
};

export const postAssistantMessage = async (
  cellPhone,
  message,
  token,
  mantisBusinessUserId,
  mantisBusinessId,
  searchType,
  workflowId,
  clientCode,
  // B-169: the Cierres chat's "Detener respuesta" cuts the request with it.
  signal
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/sapiens/postMessage`,
    {
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        cellPhone,
        message,
        mantisBusinessUserId,
        mantisBusinessId,
        searchType,
        workflowId,
        // The Cierres chat's client on screen; every other caller leaves it out.
        ...(clientCode ? { clientCode } : {})
      })
    }
  );

  return res;
};

// B-167: the Cierres chat's "Regenerar respuesta" — a new answer to the conversation's last
// question, stored in place of the last answer. `question` is the one on screen: the backend
// refuses (409 CONVERSATION_CHANGED) when the stored conversation ends in another.
export const regenerateAssistantResponse = async (
  token,
  mantisBusinessUserId,
  mantisBusinessId,
  question,
  clientCode,
  signal
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/sapiens/regenerateLastResponse`,
    {
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        mantisBusinessUserId,
        mantisBusinessId,
        question,
        ...(clientCode ? { clientCode } : {})
      })
    }
  );

  return res;
};

export const getVisionResponse = async function (
  files,
  prompt,
  token,
  mantisBusinessId,
  mantisBusinessUserId,
  mantisMissionId,
  bulk,
  missionName,
  missionDescription
) {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/vision/getVisionResponse`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        files,
        prompt,
        mantisBusinessId,
        mantisBusinessUserId,
        mantisMissionId,
        bulk,
        missionName,
        missionDescription,
      }),
    }
  );

  return res;
};

export const getMantisMissions = async (mantisBusinessId, token) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisMissions/getMantisMissionsByBusinessId`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId }),
    }
  );

  return res;
};

export const exportMantisMissions = async (mantisMissionId, token) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisMissions/exportMantisMissionsByBusinessId`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisMissionId,
      }),
    }
  );

  return res;
};

export const getMantisMissionResults = async (mantisMissionId, token) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisMissions/getMantisMissionResults`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisMissionId }),
    }
  );

  return res;
};

export const saveMantisMission = async (
  mantisBusinessId,
  mantisMission,
  mantisBusinessUserId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisMissions/saveMantisMission`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
        mantisMission,
        mantisBusinessUserId,
      }),
    }
  );

  return res;
};

export const updateFolder = async (
  folderId,
  folderData,
  mantisBusinessId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/updateFolder/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        folderId,
        folderData,
        mantisBusinessId,
      }),
    }
  );

  return res;
};

export const deleteFolder = async (folderId, mantisBusinessId, token) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/deleteFolder/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        folderId,
        mantisBusinessId,
      }),
    }
  );

  return res;
};

export const updateDocument = async (
  documentId,
  documentData,
  mantisBusinessId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/updateDocument/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",

        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        documentId,
        documentData,
        mantisBusinessId,
      }),
    }
  );

  return res;
};

export const deleteDocument = async (documentId, mantisBusinessId, token) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/deleteDocument/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",

        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        documentId,
        mantisBusinessId,
      }),
    }
  );

  return res;
};

export const getExtractedData = async (
  mantisBusinessId,
  token,
  fileCategory,
  currentPage,
  registersPerPage,
  tab,
  mantisBusinessUserId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/getExtractedData/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
        fileCategory,
        currentPage,
        registersPerPage,
        tab,
        mantisBusinessUserId,
      }),
    }
  );
  return res;
};

// B-55 — `clientCode` is which cierre client the rows belong to, and it goes last on purpose: a
// caller that passes five arguments sends the body it always sent, because `JSON.stringify` drops
// an `undefined` value rather than writing the key. `tab` is a different thing and still required
// — it selects the pipeline, not the client.
export const filterOffices = async (
  token,
  filters,
  registersPerPage,
  mantisBusinessId,
  tab,
  clientCode
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/filterOffices`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        filters,
        registersPerPage,
        tab,
        mantisBusinessId,
        clientCode,
      }),
    }
  );

  return res;
};

export const filterPqrs = async (
  token,
  filters,
  registersPerPage,
  mantisBusinessId,
  clientType,
  tab,
  mantisBusinessUserId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/filterPqrs`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",

        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        filters,
        registersPerPage,
        clientType,
        mantisBusinessId,
        type: tab,
        mantisBusinessUserId,
      }),
    }
  );

  return res;
};

export const assignPqrstoUser = async (
  token,
  mainKey,
  mantisBusinessUserId,
  mantisBusinessId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/pqrs/assignCaseToUser`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mainKey, mantisBusinessUserId, mantisBusinessId }),
    }
  );

  return res;
};

export const assignPqrstoGroup = async (
  token,
  mainKey,
  mantisBusinessGroupId,
  mantisBusinessId,
  mantisBusinessUserId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/pqrs/assignCaseToGroup`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mainKey,
        mantisBusinessGroupId,
        mantisBusinessId,
        mantisBusinessUserId,
      }),
    }
  );

  return res;
};

export const archivePQRSCase = async (
  token,
  mainKey,
  mantisBusinessId,
  archiveComment,
  mantisBusinessUserId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/pqrs/archiveCase`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mainKey,
        mantisBusinessId,
        archiveComment,
        mantisBusinessUserId,
      }),
    }
  );

  return res;
};

export const getDocumentById = async (documentId, mantisBusinessId, token) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/documentById/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        documentId,
        mantisBusinessId,
      }),
    }
  );

  return res;
};

export const getDocumentsByIds = async (
  documentIds,
  mantisBusinessId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/documentsByIds/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        documentIds,
        mantisBusinessId,
      }),
    }
  );

  return res;
};

export const getDocumentsAndEmailsByIds = async (
  ids,
  mantisBusinessId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/documentsAndEmailsByIds/`,
    {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ids,
        mantisBusinessId,
      }),
    }
  );

  return res;
};

export const feedbackAssistantMessage = async (
  mantisBusinessId,
  businessAssistantConversationId,
  assistantResponse,
  businessQuery,
  feedbackType,
  responseIndex,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/sapiens/feedbackMessage`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
        businessAssistantConversationId,
        assistantResponse,
        businessQuery,
        feedbackType,
        responseIndex,
      }),
    }
  );

  return res;
};

export const getRelatedDocumentGroup = async (
  token,
  relatedDocumentsGroupId,
  mantisBusinessId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/getRelatedDocumentsGroup`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ relatedDocumentsGroupId, mantisBusinessId }),
    }
  );

  return res;
};

export const getDocumentAlerts = async (
  token,
  relatedDocumentsGroupId,
  mantisBusinessId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/getRelatedDocumentsGroupsAlert`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ relatedDocumentsGroupId, mantisBusinessId }),
    }
  );

  return res;
};

export const updateExtractionField = async (
  token,
  field,
  value,
  mainKey,
  mantisBusinessId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/updateExtractionField`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ key: field, value, mainKey, mantisBusinessId }),
    }
  );

  return res;
};

export const sendDocumentsEmail = async (
  token,
  subject,
  message,
  recipientName,
  documentIds,
  mantisBusinessId,
  email
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/sendDocumentsEmail`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        subject,
        message,
        recipientName,
        documentIds,
        mantisBusinessId,
        email,
      }),
    }
  );

  return res;
};

export const sendTranslatableEmail = async (
  token,
  subject,
  message,
  recipientName,
  documentIds,
  mantisBusinessId,
  email,
  language
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/sendTranslatableEmail`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        subject,
        message,
        recipientName,
        documentIds,
        mantisBusinessId,
        email,
        language,
      }),
    }
  );
  return res;
};

export const respondPqrs = async (
  token,
  mantisBusinessId,
  mantisBusinessUserId,
  mainKey,
  email,
  subject,
  message,
  recipientName,
  documentIds,
  pqrsCase
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/pqrs/respond`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
        mantisBusinessUserId,
        mainKey,
        email,
        subject,
        message,
        recipientName,
        documentIds,
        pqrsCase,
      }),
    }
  );
  return res;
};

export const downloadOfficesExcel = async (
  token,
  mantisBusinessId,
  dataToExport,
  option,
  subOption
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/downloadOfficesExcel`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        dataToExport,
        option,
        subOption,
        mantisBusinessId,
      }),
    }
  );

  return res;
};

export const downloadExcel = async (
  token,
  mantisBusinessId,
  type,
  dataToExport
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/downloadExcel`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId, type, dataToExport }),
    }
  );

  return res;
};

export const getGmailConnections = async (token, mantisBusinessId) => {
  const res = await fetchWrapper(
    `${backUrl}/gmailConnections/getBusinessConnections`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId }),
    }
  );

  return res;
};

export const deleteGmailConnection = async (
  token,
  connectionId,
  mantisBusinessId
) => {
  const res = await fetchWrapper(
    `${backUrl}/gmailConnections/deleteBusinessConnection`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ connectionId, mantisBusinessId }),
    }
  );

  return res;
};

// Titan email (MA-55). The backend scopes all three to the business on the session cookie, so
// none of them sends a `mantisBusinessId`.
export const getTitanConnections = async (token) => {
  const res = await fetchWrapper(
    `${backUrl}/titanConnections/getBusinessConnections`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({}),
    }
  );

  return res;
};

export const connectTitanAccount = async (token, { email, password, region }) => {
  const res = await fetchWrapper(
    `${backUrl}/titanConnections/connect`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ email, password, region }),
    }
  );

  return res;
};

export const deleteTitanConnection = async (token, connectionId) => {
  const res = await fetchWrapper(
    `${backUrl}/titanConnections/deleteBusinessConnection`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ connectionId }),
    }
  );

  return res;
};

export const getWhatsappAccount = async (token, mantisBusinessId) => {
  const res = await fetchWrapper(
    `${backUrl}/whatsappAccountBusiness/get`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId }),
    }
  );

  return res;
};

export const createWhatsappAccount = async (
  token,
  mantisBusinessId,
  accountData
) => {
  const res = await fetchWrapper(
    `${backUrl}/whatsappAccountBusiness/create`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
        ...accountData,
      }),
    }
  );

  return res;
};

export const updateWhatsappAccount = async (
  token,
  accountId,
  accountData
) => {
  const res = await fetchWrapper(
    `${backUrl}/whatsappAccountBusiness/update`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        accountId,
        ...accountData,
      }),
    }
  );

  return res;
};

export const deleteWhatsappAccount = async (token, accountId) => {
  const res = await fetchWrapper(
    `${backUrl}/whatsappAccountBusiness/delete`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ accountId }),
    }
  );

  return res;
};

// B-55 — the column set and the names are per cierre client, so this takes one too. Optional and
// last, for the same reason as `filterOffices` above: the PQRS and tangelo panels call it with two
// arguments and their request is unchanged.
export const getExtractionFields = async (token, mantisBusinessId, clientCode) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/getExtractionFields`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId, clientCode }),
    }
  );

  return res;
};

// BR-30 — the documents behind one closing's figures, each with a short-lived signed URL or a
// reason it has none. `mantisBusinessId` is sent for consistency with every other call on this
// router and is deliberately NOT what scopes the answer: the backend takes the tenant from the
// verified session, so a body naming another business changes nothing.
export const getCierreDocuments = async (token, mantisBusinessId, closingId) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/getCierreDocuments`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId, closingId }),
    }
  );

  return res;
};

// The rows of one of a closing's spreadsheets that are about that closing — its day or its office,
// as the document's declaration says. `data.available: false` means "no preview for this one":
// the caller shows the full viewer, exactly as before.
export const getCierreDocumentPreview = async (token, mantisBusinessId, closingId, documentId) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/getCierreDocumentPreview`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId, closingId, documentId }),
    }
  );

  return res;
};

// BR-31 — the four calls a person corrects a closing through.
//
// All four are POSTs on the taktik router with the closing's uuid in the body, the shape
// `getCierreDocuments` established. The tenant and the AUTHOR both come from the session on the
// backend — `req.mantisBusinessId` and `req.userId` — so `mantisBusinessId` here is only what
// `verifyRequest` cross-checks a business session against, exactly as everywhere else. There is
// deliberately no user id in any of these bodies: the author is written into `resolved_by`,
// `recorded_by` and the event's actor, and a signature the caller chooses is not one.

export const getCierreAlerts = async (token, mantisBusinessId, closingId) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/getCierreAlerts`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId, closingId }),
    }
  );

  return res;
};

// Every alert of several closings in one request — what the "Alertas" feed calls instead of
// firing one `getCierreAlerts` per closing. `closingIds` up to 500, same cap `filterOffices`
// already returns at most.
export const getCierreAlertsBatch = async (token, mantisBusinessId, closingIds) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/getCierreAlertsBatch`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId, closingIds }),
    }
  );

  return res;
};

// B-91 — the Alertas feed of one client: its alerts in a date range (`since`/`until`, YYYY-MM-DD,
// either may be empty), each with its closing's date, office and region, plus `byDate` (every date's
// count) and `total`/`truncated`. One request in place of `filterOffices` + `getCierreAlertsBatch`.
// The business comes from the session; `mantisBusinessId` rides along like every call here.
export const listCierreAlerts = async (token, mantisBusinessId, clientCode, { since = "", until = "" } = {}) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/listCierreAlerts`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId, clientCode, since: since || null, until: until || null }),
    }
  );

  return res;
};

// The whole cuadre process behind one closing (sources, datapoints, calculations, alerts,
// events) — the Centro de Control's process/steps view. Same shape and same tenant-from-session
// caveat as `getCierreDocuments`/`getCierreAlerts` above.
export const getCierreClosingDetail = async (token, mantisBusinessId, closingId) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/getCierreClosingDetail`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId, closingId }),
    }
  );

  return res;
};

// B-115 — `adjustment`, optional: the amount as typed ("-30.000"), only for an alert the backend
// serves as `adjustable`. It moves the next day's opening balance; the backend parses it.
export const resolveCierreAlert = async (
  token,
  mantisBusinessId,
  closingId,
  alertId,
  note,
  adjustment = null
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/resolveCierreAlert`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
        closingId,
        alertId,
        note,
        ...(adjustment ? { adjustment } : {}),
      }),
    }
  );

  return res;
};

// A later version of the observation on an alert a person already attended — the Matriz's column
// AK. The backend keeps the attended note and serves this one as the alert's `resolutionNote`.
export const updateCierreAlertNote = async (
  token,
  mantisBusinessId,
  closingId,
  alertId,
  note
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/updateCierreAlertNote`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId, closingId, alertId, note }),
    }
  );

  return res;
};

// `value` is sent as the operator TYPED it — `450.000`, with Colombian separators. The backend
// parses it against the field's own declaration, because locale is declared and never inferred
// and a second number formatter in the browser is how a corrected figure and the figure it
// corrected end up disagreeing. The response carries the stored value to render back.
export const overrideCierreDatapoint = async (
  token,
  mantisBusinessId,
  closingId,
  fieldName,
  value,
  reason
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/overrideCierreDatapoint`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
        closingId,
        fieldName,
        value,
        reason,
      }),
    }
  );

  return res;
};

export const reopenCierreClosing = async (
  token,
  mantisBusinessId,
  closingId,
  reason
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/reopenCierreClosing`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId, closingId, reason }),
    }
  );

  return res;
};

// B-40 — the manual closing pipeline: open a closing, read what its office gathers, upload and read
// each document, evaluate. Same shape and same tenant-and-author-from-the-session caveat as the four
// corrections above; nothing here names a client — every list comes from the backend's profile.

const postCierre = async (token, path, body, timeout) =>
  fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/${path}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    },
    timeout
  );

export const listCierreClients = async (token, mantisBusinessId) =>
  postCierre(token, "listCierreClients", { mantisBusinessId });

// With a `businessDate`, each office also says whether its calendar keeps that day — a hint the
// picker shows before submitting, never a gate.
export const listCierreOffices = async (token, mantisBusinessId, clientCode, businessDate) =>
  postCierre(token, "listCierreOffices", { mantisBusinessId, clientCode, businessDate });

// Opening a closing that already exists is not an error: it comes back with `created: false`.
export const ensureCierreClosing = async (
  token,
  mantisBusinessId,
  clientCode,
  officeCode,
  businessDate
) =>
  postCierre(token, "ensureCierreClosing", {
    mantisBusinessId,
    clientCode,
    officeCode,
    businessDate,
  });

// The office profile's document slots and every datapoint a person may type in, with its live
// value — the same vocabulary `overrideCierreDatapoint` resolves against.
export const getCierreWorksheet = async (token, mantisBusinessId, closingId) =>
  postCierre(token, "getCierreWorksheet", { mantisBusinessId, closingId });

// Multipart, one `file`. No Content-Type header: the browser writes the boundary. The name and
// type of the file decide nothing — the backend checks the bytes against the declared format.
export const uploadCierreDocument = async (
  token,
  mantisBusinessId,
  closingId,
  documentKey,
  file
) => {
  const form = new FormData();
  form.append("mantisBusinessId", mantisBusinessId);
  form.append("closingId", closingId);
  form.append("documentKey", documentKey);
  form.append("file", file);

  return fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/uploadCierreDocument`,
    {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: form,
    },
    120000
  );
};

// B-100 — an office's documents uploaded on its closing, through its email's path: which files the
// office sends, and the files themselves (filed, read, and the closing evaluated — minutes for scans).
export const listCierreOfficeFileRules = async (token, mantisBusinessId, closingId) =>
  postCierre(token, "listCierreOfficeFileRules", { mantisBusinessId, closingId });

export const uploadCierreOfficeFiles = async (token, mantisBusinessId, closingId, files) => {
  const form = new FormData();
  form.append("mantisBusinessId", mantisBusinessId);
  form.append("closingId", closingId);
  (files || []).forEach((file) => form.append("files", file));
  return fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/uploadCierreOfficeFiles`,
    { method: "POST", headers: { Authorization: `Bearer ${token}` }, body: form },
    600000
  );
};

// Reading a scanned document goes through a model and can take a while; five minutes before the
// browser gives up rather than the default one.
export const readCierreDocument = async (token, mantisBusinessId, closingId, documentKey) =>
  postCierre(token, "readCierreDocument", { mantisBusinessId, closingId, documentKey }, 300000);

export const evaluateCierreClosing = async (token, mantisBusinessId, closingId) =>
  postCierre(token, "evaluateCierreClosing", { mantisBusinessId, closingId }, 120000);

// B-60 — a client's daily files, uploaded once for every office of the day. Multipart, one field
// per document key (`archivos` is `{ documentKey: File | null }`; empty slots are not sent). The
// backend answers 202 and keeps reading the offices after it — follow it with
// `getCierreDailyProgress`. A run already going for the client is a 409 `CONFLICT`.
export const runCierreDailyProcess = async (
  token,
  mantisBusinessId,
  clientCode,
  businessDate,
  archivos,
  { redo = false } = {}
) => {
  const form = new FormData();
  form.append("mantisBusinessId", mantisBusinessId);
  form.append("clientCode", clientCode);
  form.append("businessDate", businessDate);
  // B-80 — a day already processed is redone, and the request has to say so.
  if (redo) form.append("redo", "true");
  Object.entries(archivos || {}).forEach(([documentKey, file]) => {
    if (file) form.append(documentKey, file);
  });
  return fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/runCierreDailyProcess`,
    {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: form,
    },
    120000
  );
};

// B-80 — what redoing a processed day would throw away, across its offices. Writes nothing.
export const previewCierreDayRedo = async (token, mantisBusinessId, clientCode, businessDate) =>
  postCierre(token, "previewCierreDayRedo", { mantisBusinessId, clientCode, businessDate });

// B-80 — what redoing one closing would throw away (documents, typed values, attended alerts).
export const previewCierreRedo = async (token, mantisBusinessId, closingId) =>
  postCierre(token, "previewCierreRedo", { mantisBusinessId, closingId });

// B-80 — redo one closing from its reports. Files optional, one multipart field per document key;
// the documents not sent are read again from what is stored. Reads every document again, so it
// gets the daily run's long timeout.
export const redoCierreClosing = async (token, mantisBusinessId, closingId, archivos, motivo) => {
  const form = new FormData();
  form.append("mantisBusinessId", mantisBusinessId);
  form.append("closingId", closingId);
  if (motivo && motivo.trim()) form.append("reason", motivo.trim());
  Object.entries(archivos || {}).forEach(([documentKey, file]) => {
    if (file) form.append(documentKey, file);
  });

  return fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/redoCierreClosing`,
    {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: form,
    },
    600000
  );
};

// Where that day stands: `running`, the office counts, and each closing's latest read per daily
// document. Its `documents` map is keyed by the client's daily document keys even before a run.
export const getCierreDailyProgress = async (token, mantisBusinessId, clientCode, businessDate) =>
  postCierre(token, "getCierreDailyProgress", { mantisBusinessId, clientCode, businessDate });

// B-77 — the signed-in person's own "Procesar el día" notifications (the Cierres bell). The backend
// takes the person and the business from the session; nothing here names either.
export const listCierreRunNotifications = async (token) => postCierre(token, "listCierreRunNotifications", {});

// `ids` omitted marks all of them.
export const markCierreRunNotificationsRead = async (token, ids) =>
  postCierre(token, "markCierreRunNotificationsRead", ids ? { ids } : {});

// B-70 — every date a client has daily closings on, a page at a time, newest first, each with its
// closings grouped by state / missing report / blocking alert and its daily documents' counts:
// `{ total, limit, offset, documentKeys, dates: [{ businessDate, closings, groups, documents }] }`.
// `since` and `until` are inclusive; `limit` is 1–100.
export const getCierreClosingDates = async (token, mantisBusinessId, clientCode, { since, until, limit, offset } = {}) =>
  postCierre(token, "getCierreClosingDates", { mantisBusinessId, clientCode, since, until, limit, offset });

// B-72 — the Saturdays a client works ("Sábados laborales", under the Calendario). Reading them needs
// the client in view; every change, and reading a picture, needs `cierres.daily.run` on the whole
// client. Nothing names a client here: `clientCode` is the shell's selector.

// `{ clientCode, today, dates: [{ id, date, source, sourceFile, note, createdBy, createdAt, past,
// closings }], removed }` — `removed` (the history) only with `includeRemoved`.
export const listCierreOpenDates = async (token, mantisBusinessId, clientCode, includeRemoved = false) =>
  postCierre(token, "listCierreOpenDates", { mantisBusinessId, clientCode, includeRemoved });

// Multipart, one `file` (an image or a PDF of the client's list). perlita reads it, which takes
// several seconds, so the backend answers as it goes — NDJSON, read like `sendCierreDailyReport`:
// each step (`file`, `read`, `review`) goes to `onProgress`, and the outcome is returned — a
// proposal, `{ fileName, notes, review: [{ input, date, ok, problems, warnings, messages }] }`.
// Nothing is saved until `addCierreOpenDates`. Null when the backend could not be reached.
export const previewCierreOpenDates = async (token, mantisBusinessId, clientCode, file, onProgress = null) => {
  const form = new FormData();
  form.append("mantisBusinessId", mantisBusinessId);
  form.append("clientCode", clientCode);
  form.append("file", file);

  let response;
  try {
    response = await fetch(
      `${backUrl}/mantisBusiness/taktik/previewCierreOpenDates`,
      withAuthCredentials({
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: form,
      })
    );
  } catch (error) {
    console.error("Error en previewCierreOpenDates:", error);
    return null;
  }
  if (response.status === 401) {
    handleSessionExpiration();
    return null;
  }
  // Refused before the stream started (auth, the upload's size limit): a plain JSON answer.
  if (!response.ok || !response.body) return response.json().catch(() => null);
  return leerEventos(response.body.getReader(), onProgress);
};

// All of them or none: one date that is not a Saturday, or already listed, refuses the list.
// `source` is "image" (with the picture's `sourceFile`) or "manual".
export const addCierreOpenDates = async (token, mantisBusinessId, clientCode, { dates, source, sourceFile, note }) =>
  postCierre(token, "addCierreOpenDates", { mantisBusinessId, clientCode, dates, source, sourceFile, note });

// A Saturday that already has closings cannot be moved (409 `OPEN_DATE_HAS_CLOSINGS`).
export const updateCierreOpenDate = async (token, mantisBusinessId, clientCode, { id, date, note }) =>
  postCierre(token, "updateCierreOpenDate", { mantisBusinessId, clientCode, id, date, note });

// Nor removed: the same 409.
export const removeCierreOpenDate = async (token, mantisBusinessId, clientCode, id) =>
  postCierre(token, "removeCierreOpenDate", { mantisBusinessId, clientCode, id });

// B-71 — "Enviar consolidado": one day's report (summary, everything open, the Matriz attached) to
// `recipients`, or to the client's configured recipients when none are given.
//
// The backend answers as it goes — NDJSON, one line per step — so this reads the body as it arrives
// instead of through `fetchWrapper`, which waits for it whole: each step goes to `onProgress` and the
// outcome (`{ success, data | errorCode, message }`) is returned. Same cookie, CSRF header and
// expired-session handling as `fetchWrapper`. Null when the backend could not be reached.
// "Enviar consolidado"'s preview: the same email, built by the backend and returned — `{ subject,
// html, text, attachment }` — never sent, and without building the Matriz (its name only).
export const previewCierreDailyReport = async (token, mantisBusinessId, clientCode, businessDate, comment = null) =>
  postCierre(token, "previewCierreDailyReport", { mantisBusinessId, clientCode, businessDate, comment }, 120000);

export const sendCierreDailyReport = async (
  token,
  mantisBusinessId,
  clientCode,
  businessDate,
  recipients = [],
  onProgress = null,
  comment = null
) => {
  let response;
  try {
    response = await fetch(
      `${backUrl}/mantisBusiness/taktik/sendCierreDailyReport`,
      withAuthCredentials({
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ mantisBusinessId, clientCode, businessDate, recipients, comment }),
      })
    );
  } catch (error) {
    console.error("Error en sendCierreDailyReport:", error);
    return null;
  }
  if (response.status === 401) {
    handleSessionExpiration();
    return null;
  }
  // Refused before the stream started (the access middleware): a plain JSON answer.
  if (!response.ok || !response.body) return response.json().catch(() => null);
  return leerEventos(response.body.getReader(), onProgress);
};

/**
 * B-88 — one closing as a ZIP: every current document, the extracted values and the whole history.
 * Not through `fetchWrapper`, which parses JSON: on success the body is the ZIP. A refusal (403 for
 * documents the person may not see, 404 for a closing outside their view) is the usual JSON, handed
 * back as is so `correctionError` can say it. The file name is the caller's: the API is another
 * origin and does not expose `Content-Disposition`, so the browser hides it.
 *
 * @returns {Promise<{ success: true, blob: Blob, filename: string } | object | null>}
 */
export const downloadCierreClosingArchive = async (token, mantisBusinessId, closingId, filename = "cierre.zip") => {
  let response;
  try {
    response = await fetch(
      `${backUrl}/mantisBusiness/taktik/downloadCierreClosingArchive`,
      withAuthCredentials({
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ mantisBusinessId, closingId }),
      })
    );
  } catch (error) {
    console.error("Error en downloadCierreClosingArchive:", error);
    return null;
  }
  if (response.status === 401) {
    handleSessionExpiration();
    return null;
  }
  if (!response.ok) return response.json().catch(() => null);
  return { success: true, blob: await response.blob(), filename };
};

/**
 * B-104 — the cashiers' Drive for the next business day, as a blob named by the server (the next business
 * day depends on the holidays). A refusal is the JSON answer: a 409 names the offices without a balance in
 * `data.oficinasSinSaldo`.
 */
export const downloadCierreNextDayDrive = async (token, mantisBusinessId, clientCode, businessDate) => {
  let response;
  try {
    response = await fetch(
      `${backUrl}/mantisBusiness/taktik/downloadCierreNextDayDrive`,
      withAuthCredentials({
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ mantisBusinessId, clientCode, businessDate }),
      })
    );
  } catch (error) {
    console.error("Error en downloadCierreNextDayDrive:", error);
    return null;
  }
  if (response.status === 401) {
    handleSessionExpiration();
    return null;
  }
  if (!response.ok) return response.json().catch(() => null);
  const disposition = response.headers.get("Content-Disposition") || "";
  const match = /filename="([^"]+)"/.exec(disposition);
  return { success: true, blob: await response.blob(), filename: match ? match[1] : "DRIVE CUADRE CAJA.xlsx" };
};

/** B-105 — TX and value billed to the bank per office and concept, between two dates (366 days at most). */
export const getCierreBillingSummary = async (token, mantisBusinessId, clientCode, { from, to }) =>
  postCierre(token, "getCierreBillingSummary", { mantisBusinessId, clientCode, from, to });

/**
 * B-136 — the client's follow-up committee for a month (`{ month }`) or a range (`{ from, to }`), optionally
 * for the offices chosen on the map (`offices`), and the period before it: transactions
 * and amounts per office and day, vault excesses, reversals. 404 for a client that declares none.
 */
export const getCierreOperationReport = async (token, mantisBusinessId, clientCode, pedido) =>
  postCierre(token, "getCierreOperationReport", { mantisBusinessId, clientCode, ...pedido }, 120000);

/**
 * B-154 — Banco Agrario's transactions and reversals since January 2024: `{ from, to, offices }`, all
 * optional (from the client's start to today). A 404 for a client without the dashboard.
 */
export const getCierreTransactionsDashboard = async (token, mantisBusinessId, clientCode, pedido = {}) =>
  postCierre(token, "getCierreTransactionsDashboard", { mantisBusinessId, clientCode, ...pedido }, 120000);

/** B-154 — the reversals recorded on one closing; `enabled: false` for a client that records none. */
export const listCierreReversals = async (token, mantisBusinessId, closingId) =>
  postCierre(token, "listCierreReversals", { mantisBusinessId, closingId });

/**
 * B-154 — a reversal recorded on a closing: the fields of the bank's form CN-FT-045 and, optionally, the
 * signed form. Multipart, like the other uploads.
 */
export const createCierreReversal = async (token, mantisBusinessId, closingId, campos, archivo = null) => {
  const form = new FormData();
  form.append("mantisBusinessId", mantisBusinessId);
  form.append("closingId", closingId);
  Object.entries(campos || {}).forEach(([clave, valor]) => {
    if (valor !== undefined && valor !== null && valor !== "") form.append(clave, String(valor));
  });
  if (archivo) form.append("file", archivo);
  return fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/createCierreReversal`,
    { method: "POST", headers: { Authorization: `Bearer ${token}` }, body: form },
    120000
  );
};

/**
 * B-159 — a reversal the bank's file proposed, completed from its signed form: the cashier, the motive,
 * the attribution and the rest of the form's half, and optionally the form. Multipart, like recording one.
 */
export const completeCierreReversal = async (token, mantisBusinessId, id, campos, archivo = null) => {
  const form = new FormData();
  form.append("mantisBusinessId", mantisBusinessId);
  form.append("id", id);
  Object.entries(campos || {}).forEach(([clave, valor]) => {
    if (valor !== undefined && valor !== null && valor !== "") form.append(clave, String(valor));
  });
  if (archivo) form.append("file", archivo);
  return fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/completeCierreReversal`,
    { method: "POST", headers: { Authorization: `Bearer ${token}` }, body: form },
    120000
  );
};

/**
 * B-160 — the signed form CN-FT-045 read into a proposal (`{ form, checks }`); nothing is saved. For a
 * reversal (`{ id }`) or a new one on a closing (`{ closingId }`).
 */
export const readCierreReversalForm = async (token, mantisBusinessId, destino, archivo) => {
  const form = new FormData();
  form.append("mantisBusinessId", mantisBusinessId);
  if (destino?.id) form.append("id", destino.id);
  if (destino?.closingId) form.append("closingId", destino.closingId);
  if (archivo) form.append("file", archivo);
  return fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/readCierreReversalForm`,
    { method: "POST", headers: { Authorization: `Bearer ${token}` }, body: form },
    180000
  );
};

/** B-164 — a form that reached the office by itself, associated with one of the closing's reversals. */
export const attachCierreReversalForm = async (token, mantisBusinessId, formId, reversalId) =>
  postCierre(token, "attachCierreReversalForm", { mantisBusinessId, formId, reversalId });

/** B-154 — a reversal recorded by mistake, withdrawn (its row stays). */
export const withdrawCierreReversal = async (token, mantisBusinessId, id) =>
  postCierre(token, "withdrawCierreReversal", { mantisBusinessId, id });

/** B-139 — the team's dashboard for `{ from, to }` (92 days at most): queue, people, response times, days. */
/** B-139 — Reportes' "Equipo" tab for a range of 92 days at most; with `from` null, everything ("Todo"). */
export const getCierreTeamActivity = async (token, mantisBusinessId, clientCode, from, to) =>
  postCierre(token, "getCierreTeamActivity", from ? { mantisBusinessId, clientCode, from, to } : { mantisBusinessId, clientCode, all: true }, 60000);

/** B-89 — the client's offices with their own email addresses, and whether each may be changed here. */
export const listCierreOfficeContacts = async (token, mantisBusinessId, clientCode) =>
  postCierre(token, "listCierreOfficeContacts", { mantisBusinessId, clientCode });

/** B-89 — change one office's addresses, or many offices' at once (the Excel import). All or nothing. */
export const saveCierreOfficeContacts = async (token, mantisBusinessId, clientCode, offices) =>
  postCierre(token, "saveCierreOfficeContacts", { mantisBusinessId, clientCode, offices });

/**
 * B-134 — each office's "Máquina GLORY" switch, its last change and whether this person may change it.
 * `supported: false` for a client with no GLORY to configure. `officeCode` narrows it to one office.
 */
export const listCierreOfficeGlory = async (token, mantisBusinessId, clientCode, officeCode) =>
  postCierre(token, "listCierreOfficeGlory", { mantisBusinessId, clientCode, ...(officeCode ? { officeCode } : {}) });

/** B-134 — every change of one office's GLORY switch, newest first. */
export const listCierreOfficeGloryHistory = async (token, mantisBusinessId, clientCode, officeCode) =>
  postCierre(token, "listCierreOfficeGloryHistory", { mantisBusinessId, clientCode, officeCode });

/**
 * B-134 — turn an office's GLORY on or off (`cambio`: `{ enabled, reasonCode?, note? }`). Off needs a
 * `reasonCode`, and `note` for `OTHER`. Applies from the office's next evaluation.
 */
export const saveCierreOfficeGlory = async (token, mantisBusinessId, clientCode, officeCode, cambio) =>
  postCierre(token, "saveCierreOfficeGlory", { mantisBusinessId, clientCode, officeCode, ...cambio });

/**
 * "Añadir oficina" — a new office of the client: `oficina` is `{ officeCode, name, dane, region,
 * departamento?, acceso?, cupo?, emails?, glory? }`. Needs `cierres.offices.configure` on the whole
 * client; a code the client already has is a 409.
 */
export const createCierreOffice = async (token, mantisBusinessId, clientCode, oficina) =>
  postCierre(token, "createCierreOffice", { mantisBusinessId, clientCode, ...oficina });

/**
 * B-92 — "Configuración de alertas": who gets the client's day email and its urgent email, which
 * alerts are urgent (the client's own, by label), and whether this person may change them.
 */
export const getCierreNotificationSettings = async (token, mantisBusinessId, clientCode) =>
  postCierre(token, "getCierreNotificationSettings", { mantisBusinessId, clientCode });

/** B-92 — change those lists. Carries only what it changes: `{ recipients?, enabled?, urgent? }`. */
export const saveCierreNotificationSettings = async (token, mantisBusinessId, clientCode, changes) =>
  postCierre(token, "saveCierreNotificationSettings", { mantisBusinessId, clientCode, ...changes });

/**
 * B-92 — the urgent email as a recipient would read it, over an example office; nothing is sent.
 * `message` is the one being typed (not saved yet); left out, the saved one is shown.
 */
export const previewCierreUrgentEmail = async (token, mantisBusinessId, clientCode, message) =>
  postCierre(token, "previewCierreUrgentEmail", {
    mantisBusinessId,
    clientCode,
    ...(message === undefined ? {} : { message }),
  });

/** B-89 — each office's email as it would go, nothing sent. */
export const previewCierreOfficeReport = async (token, mantisBusinessId, closingIds, comment = null) =>
  postCierre(token, "previewCierreOfficeReport", { mantisBusinessId, closingIds, comment }, 120000);

/**
 * B-89 — send each chosen office its own closing report, to its own addresses. Answered as it goes
 * (NDJSON), like "Enviar consolidado": `onProgress` hears each office; the result lists every office
 * with SENT, NO_RECIPIENTS or FAILED.
 */
export const sendCierreOfficeReport = async (token, mantisBusinessId, closingIds, onProgress = null, comment = null) => {
  let response;
  try {
    response = await fetch(
      `${backUrl}/mantisBusiness/taktik/sendCierreOfficeReport`,
      withAuthCredentials({
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ mantisBusinessId, closingIds, comment }),
      })
    );
  } catch (error) {
    console.error("Error en sendCierreOfficeReport:", error);
    return null;
  }
  if (response.status === 401) {
    handleSessionExpiration();
    return null;
  }
  if (!response.ok || !response.body) return response.json().catch(() => null);
  return leerEventos(response.body.getReader(), onProgress);
};

export const getExtractionDropdownOptions = async (token, mantisBusinessId) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/getExtractionDropdownOptions`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId }),
    }
  );

  return res;
};

export const getDocumentSignedUrl = async (
  token,
  documentId,
  mantisBusinessId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/getDocumentSignedUrl`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ documentId, mantisBusinessId }),
    }
  );

  return res;
};

export const addDocumentToRelatedDocumentsGroup = async (
  token,
  mantisBusinessId,
  mantisBusinessUserId,
  base64,
  name,
  type,
  fileDate,
  fileSize,
  relatedDocumentsGroupId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/addDocumentToRelatedDocumentsGroup`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
        mantisBusinessUserId,
        base64,
        name,
        type,
        fileDate,
        fileSize,
        relatedDocumentsGroupId,
      }),
    }
  );

  return res;
};

export const getMantisBusinessGroups = async (mantisBusinessId, token) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/userManagement/getGroups`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
      }),
    }
  );
  return res;
};
export const createMantisBusinessGroup = async (
  mantisBusinessId,
  token,
  groupData,
  supervisorId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/userManagement/createGroup`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
        groupData,
        supervisorId,
      }),
    }
  );
  return res;
};
export const editMantisBusinessGroup = async (
  mantisBusinessId,
  groupId,
  groupData,
  supervisorId,
  assignedUserIds,
  token
) => {
  try {
    const res = await fetchWrapper(
      `${backUrl}/mantisBusiness/userManagement/editGroup`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          mantisBusinessId,
          groupId,
          groupData,
          supervisorId,
          assignedUserIds,
        }),
      }
    );
    return res;
  } catch (error) {
    console.error("Error en editMantisBusinessGroup:", error);
    throw error;
  }
};

export const deleteMantisBusinessGroup = async (
  mantisBusinessId,
  groupId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/userManagement/deleteGroup`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
        groupId,
      }),
    }
  );
  return res;
};

export const getSupervisors = async (mantisBusinessId, token) => {
  try {
    const res = await fetchWrapper(
      `${backUrl}/mantisBusiness/userManagement/getSupervisors`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ mantisBusinessId }),
      }
    );

    return res;
  } catch (error) {
    console.error("Error en la solicitud de supervisores:", error);
    return {
      success: false,
      message: error.message,
    };
  }
};

export const getInternalMessages = async (
  mantisBusinessId,
  token,
  mantisBusinessUserId
) => {
  const res = await fetchWrapper(`${backUrl}/internalMessages/getInbox`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ mantisBusinessId, mantisBusinessUserId }),
  });

  return res;
};

export const updatePqrsPriority = async (
  token,
  mainKey,
  priority,
  mantisBusinessId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/pqrs/updatePriority`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
        mainKey,
        priority,
      }),
    }
  );
  return res;
};

export const getDocumentFormats = async (token, mantisBusinessId) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/archive/getDocumentFormats`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId }),
    }
  );

  return res;
};

export const updatePqrsResponseDate = async (
  token,
  mainKey,
  responseDate,
  mantisBusinessId
) => {
  const res = await fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/pqrs/updateResponseDate`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mantisBusinessId, mainKey, responseDate }),
    }
  );

  return res;
};

export const updatePqrsGroup = async (
  token,
  mainKey,
  groupId,
  groupName,
  mantisBusinessId
) => {
  console.log("esta es la data", {
    mantisBusinessId,
    mainKey,
    groupId,
    groupName,
  });
  const res = await fetchWrapper(`${backUrl}/mantisBusiness/taktik/pqrs/updateGroup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ mantisBusinessId, mainKey, groupId, groupName }),
  });
  return res;
};

export const getFormatFieldValues = async (
  token,
  mantisBusinessId,
  formatId,
  base64,
  filename,
  fileSize,
  fileType,
  documentId
) => {
  try {
    const res = await fetchWrapper(
      `${backUrl}/mantisBusiness/archive/getFormatFieldValues`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          mantisBusinessId,
          formatId,
          base64,
          filename,
          fileSize,
          fileType,
          documentId,
        }),
      },
      180000
    );
    return res;
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
};

export const cloneRadicado = async (
  token,
  businessId,
  userId,
  originalMainKey,
  responseData
) => {
  try {
    const response = await fetchWrapper(
      `${backUrl}/mantisBusiness/taktik/pqrs/cloneCase`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          mainKey: originalMainKey,
          responseData: {
            ...responseData,
            originalCase: {
              ...responseData.originalCase,
              mantis_business_id: businessId,
            },
          },
          mantisBusinessId: businessId,
          mantisBusinessUserId: userId,
        }),
      }
    );
    return {
      success: response.status === 200,
      ...response,
    };
  } catch (error) {
    console.error("Error cloning radicado:", error);
    return {
      success: false,
      error: error.message || "No se pudo crear el radicado",
    };
  }
};

export const getGroupUsers = async (token, mantisBusinessId, groupId) => {
  try {
    const response = await fetchWrapper(
      `${backUrl}/mantisBusiness/userManagement/getGroups`,
      {
        method: "POST",
        headers: {

          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          groupId,
          mantisBusinessId,
        }),
      }
    );
    return {
      success: response.status === 200,
      ...response,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "No se pudieron obtener los grupos",
    };
  }
};

export const searchInArchive = async (token, mantisBusinessId, searchTerm) => {
  try {
    const response = await fetchWrapper(
      `${backUrl}/mantisBusiness/archive/search`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          mantisBusinessId,
          searchTerm
        })
      },
      360000
    );
    return {
      success: response.status === 200,
      ...response,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "No se pudieron obtener los grupos",
    };
  }
};

export const moveDocumentsToFolder = async (
  token,
  mantisBusinessId,
  documentIds,
  folderId
) => {
  try {
    const response = await fetchWrapper(
      `${backUrl}/mantisBusiness/archive/moveDocumentsToFolder`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          mantisBusinessId,
          documentIds,
          folderId,
        }),
      }
    );
    return {
      success: response.status === 200,
      ...response,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "No se pudieron obtener los grupos",
    };
  }
};

export const updateMultipleWhatsappContacts = async (
  flowId,
  contacts,
  mantisBusinessId,
  token
) => {
  try {
    const url = `${backUrl}/businessFlows/updateMultipleWhatsappContacts?flowId=${flowId}&mantisBusinessId=${mantisBusinessId}`;

    const response = await fetchWrapper(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        contacts,
      }),
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateFlowResultFieldByColumnName = async (
  token,
  flowResultId,
  mantisBusinessId,
  columnName,
  value
) => {
  try {
    const response = await fetchWrapper(
      `${backUrl}/businessFlows/updateFlowResultFieldByColumnName`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          flowResultId,
          mantisBusinessId,
          columnName,
          newValue: value,
        }),
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const generateStripePaymentLink = async (token, paymentData) => {
  try {
    const response = await fetchWrapper(`${backUrl}/stripe/payment-links`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(paymentData),
    });

    return {
      success: response.status === 200,
      ...response,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "Error al generar enlace de pago",
    };
  }
};

export const generateSubscriptionPaymentLink = async (token, subscriptionData) => {
  try {
    // Validate required fields
    if (!subscriptionData.subscriptionAmount || !subscriptionData.description) {
      return {
        success: false,
        error: "Subscription amount and description are required fields"
      };
    }

    // Validate subscription amount is positive
    if (subscriptionData.subscriptionAmount <= 0) {
      return {
        success: false,
        error: "Subscription amount must be greater than 0"
      };
    }

    // Validate setup fee if provided
    if (subscriptionData.setupFee && subscriptionData.setupFee < 0) {
      return {
        success: false,
        error: "Setup fee cannot be negative"
      };
    }

    const response = await fetchWrapper(`${backUrl}/stripe/subscription-links`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        subscriptionAmount: subscriptionData.subscriptionAmount,
        description: subscriptionData.description,
        setupFee: subscriptionData.setupFee || 0,
        currency: subscriptionData.currency || 'usd',
        customer_email: subscriptionData.customer_email,
        metadata: subscriptionData.metadata || {},
        success_url: subscriptionData.success_url,
        subscriptionInterval: subscriptionData.subscriptionInterval || 'month',
        subscriptionIntervalCount: subscriptionData.subscriptionIntervalCount || 1,
        trialPeriodDays: subscriptionData.trialPeriodDays || null
      }),
    });

    return {
      success: response.status === 200,
      ...response,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "Error al generar enlace de suscripción",
    };
  }
};

export const generateSetupFeeSubscriptionCheckout = async (token, subscriptionData) => {
  try {
    // Validate required fields
    if (!subscriptionData.subscriptionAmount || !subscriptionData.description) {
      return {
        success: false,
        error: "Subscription amount and description are required fields"
      };
    }

    // Validate subscription amount is positive
    if (subscriptionData.subscriptionAmount <= 0) {
      return {
        success: false,
        error: "Subscription amount must be greater than 0"
      };
    }

    // Validate setup fee is positive
    if (!subscriptionData.setupFee || subscriptionData.setupFee <= 0) {
      return {
        success: false,
        error: "Setup fee must be greater than 0 for this checkout type"
      };
    }

    const response = await fetchWrapper(`${backUrl}/stripe/setup-fee-subscription`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        subscriptionAmount: subscriptionData.subscriptionAmount,
        description: subscriptionData.description,
        setupFee: subscriptionData.setupFee,
        currency: subscriptionData.currency || 'usd',
        customer_email: subscriptionData.customer_email,
        metadata: subscriptionData.metadata || {},
        success_url: subscriptionData.success_url,
        cancel_url: subscriptionData.cancel_url,
        subscriptionInterval: subscriptionData.subscriptionInterval || 'month',
        subscriptionIntervalCount: subscriptionData.subscriptionIntervalCount || 1,
        trialPeriodDays: subscriptionData.trialPeriodDays || null
      }),
    });

    return {
      success: response.status === 200,
      ...response,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "Error al generar checkout de suscripción con tarifa de configuración",
    };
  }
};
// B-101 — the client's day: Σ the offices against the account, the controls, the pending notes
// and the residual. `{ success, data }`; a client with no day reconciliation answers 404.
/** B-162 — the client's reconciliation close over `{ from, to }` (92 days at most): days, totals, offices, rules. */
export const getCierreReconciliationReport = async (token, mantisBusinessId, clientCode, { from, to }) =>
  postCierre(token, "getCierreReconciliationReport", { mantisBusinessId, clientCode, from, to }, 120000);

export const getCierreDayReconciliation = async (token, mantisBusinessId, clientCode, businessDate) =>
  postCierre(token, "getCierreDayReconciliation", { mantisBusinessId, clientCode, businessDate });

// B-101 — the pending notes, of the client or one office, in the person's view.
export const listCierrePendingItems = async (token, mantisBusinessId, clientCode, { officeCode, status } = {}) =>
  postCierre(token, "listCierrePendingItems", { mantisBusinessId, clientCode, officeCode, status });

// B-101 — a person's pending note: `{ officeCode, amount, note, openedOn? }`, kind MANUAL.
export const createCierrePendingItem = async (token, mantisBusinessId, clientCode, item) =>
  postCierre(token, "createCierrePendingItem", { mantisBusinessId, clientCode, kind: "MANUAL", ...item });

export const updateCierrePendingItem = async (token, mantisBusinessId, clientCode, id, note, amount) =>
  postCierre(token, "updateCierrePendingItem", { mantisBusinessId, clientCode, id, note, amount });

export const closeCierrePendingItem = async (token, mantisBusinessId, clientCode, id, note, closedOn) =>
  postCierre(token, "closeCierrePendingItem", { mantisBusinessId, clientCode, id, note, closedOn });

// B-103 — the emails to an office. A note it has to correct goes through
// `sendCierrePendingItemNotice` (no concept, no file); these are the missing documents of a closing
// and the cash differences for CNN. `preview` returns the email and sends nothing; `to` empty is
// the office's own addresses (required for the zone coordinator).
export const sendCierreMissingDocumentsNotice = async (token, mantisBusinessId, { closingId, comment, to, preview = false }) =>
  postCierre(token, "sendCierreMissingDocumentsNotice", { mantisBusinessId, closingId, comment, to, preview });

export const listCierreCashDifferences = async (token, mantisBusinessId, clientCode, { from, to, status } = {}) =>
  postCierre(token, "listCierreCashDifferences", { mantisBusinessId, clientCode, from, to, status });

export const markCierreCashDifferenceCreated = async (token, mantisBusinessId, clientCode, { closingId, createdOn, note, undo = false }) =>
  postCierre(token, "markCierreCashDifferenceCreated", { mantisBusinessId, clientCode, closingId, createdOn, note, undo });

export const sendCierreCashDifferenceNotice = async (token, mantisBusinessId, clientCode, { closingId, to, comment, preview = false }) =>
  postCierre(token, "sendCierreCashDifferenceNotice", { mantisBusinessId, clientCode, closingId, to, comment, preview });

// B-102 — a "Transacción en vuelo" note proposed to the bank: previewed (`preview`) or sent, with the
// cashier's support as `file`. `to` empty is the client's own recipients.
export const sendCierrePendingItemNotice = async (
  token,
  mantisBusinessId,
  clientCode,
  { id, concept, value, comment, to, file, preview = false }
) => {
  const form = new FormData();
  form.append("mantisBusinessId", mantisBusinessId);
  form.append("clientCode", clientCode);
  form.append("id", id);
  if (concept) form.append("concept", concept);
  if (value) form.append("value", value);
  if (comment) form.append("comment", comment);
  if (to) form.append("to", to);
  if (preview) form.append("preview", "true");
  if (file) form.append("file", file);
  return fetchWrapper(
    `${backUrl}/mantisBusiness/taktik/sendCierrePendingItemNotice`,
    { method: "POST", headers: { Authorization: `Bearer ${token}` }, body: form },
    120000
  );
};
